// Location coordinates and metadata
export const LOCATIONS = {
  srinagar: {
    lat: 34.07353464092054,
    lng: 74.84625008009704,
    name: "Sonwar Bagh, Srinagar (J&K)",
    displayName: "Sonwar Bagh, Srinagar (J&K)",
  },
  // baramulla: {
  //   lat: 34.15552894901031,
  //   lng: 74.64791831074348,
  //   name: "SSM College, Pattan (J&K)",
  //   displayName: "SSM College, Pattan (J&K)",
  // },
  jammu: {
    lat: 32.74796901554178,
    lng: 74.81620154731503,
    name: "KC Sports Club, Paloura, Akhnoor Road, Jammu (J&K)",
    displayName: "KC Sports Club, Paloura, Akhnoor Road, Jammu (J&K)",
  },
};

// Calculate distance between two points using Haversine formula
export const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const R = 6371; // Earth's radius in km
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

// Find nearest location to user coordinates
export const findNearestLocation = (userLat, userLng) => {
  let nearest = null;
  let minDistance = Infinity;

  Object.entries(LOCATIONS).forEach(([key, location]) => {
    const distance = calculateDistance(
      userLat,
      userLng,
      location.lat,
      location.lng
    );
    if (distance < minDistance) {
      minDistance = distance;
      nearest = key;
    }
  });

  return { location: nearest, distance: minDistance };
};

// Get user's current location
export const getUserLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation not supported"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (error) => {
        reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000, // 5 minutes
      }
    );
  });
};
